<template>
  <section class="service">
    <h1 class="title">
      <span>our services</span>
      <a class="text-decoration-none" href=""> view all >></a>
    </h1>
    <div class="box-container">
      <div class="box">
        <img :src="serviceOne" alt="" />
        <h3>product selling</h3>
        <p>
          Lorem ipsum dolor sit amet consectetur adipisicing elit. Voluptates,
          quod.
        </p>
        <router-link to="#" class="btn">read more</router-link>
      </div>

      <div class="box">
        <img :src="serviceTwo" alt="" />
        <h3>product designing</h3>
        <p>
          Lorem ipsum dolor sit amet consectetur adipisicing elit. Voluptates,
          quod.
        </p>
        <router-link to="#" class="btn">read more</router-link>
      </div>

      <div class="box">
        <img :src="serviceThree" alt="" />
        <h3>24 / 7 support</h3>
        <p>
          Lorem ipsum dolor sit amet consectetur adipisicing elit. Voluptates,
          quod.
        </p>
        <router-link to="#" class="btn">read more</router-link>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  data() {
    return {
      serviceOne: require("@/images/serv-1.svg"),
      serviceTwo: require("@/images/serv-2.svg"),
      serviceThree: require("@/images/serv-3.svg"),
    };
  },
};
</script>